import {HttpHeaders} from '@angular/common/http';

export function appendAnonymousHeader(thirdParty: string, headers: HttpHeaders): HttpHeaders {
    const authorization: string = btoa(`${thirdParty}/CORE/anonymous:294de3557d9d00b3d2d8a1e6aab028cf`);
    return headers.append('Authorization', `Basic ${authorization}`);
}

